export default {
  data () {
    return {
      quantity: 2,
      innerSelectedCondition: 'order.noTaxable'
    }
  },
  methods: {
    callbackPrinter () {
      return new Promise((resolve) => {
        const quantity = this.quantity
        const purchases = []
        this.$_.times(quantity, (n) => {
          purchases.push({
            sequence: `${n + 1}.`,
            name: `Apple-${n + 1}`,
            code: `apple-${n + 1}`,
            quantity: 1,
            price: 1000,
            discountValue: 0,
            subtotal: 1000,
            priceTax: 1007
          })
        })

        const cod = this.innerSelectedCondition === 'order.cod'
        const noCod = this.innerSelectedCondition === 'order.noCod'
        const taxable = this.innerSelectedCondition === 'order.taxable'
        const noTaxable = this.innerSelectedCondition === 'order.noTaxable'
        const codWithTaxable = this.innerSelectedCondition === 'order.codWithTaxable'
        const codWithNoTaxable = this.innerSelectedCondition === 'order.codWithNoTaxable'
        const noCodWithTaxable = this.innerSelectedCondition === 'order.noCodWithTaxable'
        const noCodWithNoTaxable = this.innerSelectedCondition === 'order.noCodWithNoTaxable'
        resolve({
          nodesCount: 1,
          pagesCount: 1,
          nodes: [{
            page: {
              page: 1,
              pagesCount: 1
            },
            order: {
              id: '12345',
              name: 'John Doe',
              email: 'johndoe@mail.com',
              quantity,
              cartQuantity: quantity,
              purchasesSize: quantity,
              price: 2300,
              beforeDiscount: 2300,
              tax: 100,
              beforeTax: 2200,
              barcode: 'shipnity',
              shippingBarcode: 'shipnity',
              address: '888/888 อัลคาเทลนครพนมราหุลโอเดียน อีซูซุลิเวอร์พูลโฮจิมินห์เกตส์ โนเบล กรุงเทพ 10000',
              taxName: 'John Die',
              taxAddress: '777/777 อัลคาเทลนครพนมราหุลโอเดียน อีซูซุลิเวอร์พูลโฮจิมินห์เกตส์ โนเบล กรุงเทพ 20000',
              taxTel: '02222222',
              addressWithoutZipcode: '777/777 อัลคาเทลนครพนมราหุลโอเดียน อีซูซุลิเวอร์พูลโฮจิมินห์เกตส์ โนเบล กรุงเทพ',
              zipcode: '10000',
              shipFromAddress: '888/888 อัลคาเทลนครพนมราหุลโอเดียน อีซูซุลิเวอร์พูลโฮจิมินห์เกตส์ โนเบล กรุงเทพ 10000',
              shipFromTaxId: '11222333232232',
              shipFromAddresssWithoutZipcode: '888/888 อัลคาเทลนครพนมราหุลโอเดียน อีซูซุลิเวอร์พูลโฮจิมินห์เกตส์ โนเบล กรุงเทพ',
              shipFromZipcode: '10000',
              shipFromTel: '02222223',
              shipFromName: 'John Doe',
              tag: 'Facebook',
              orderBank: 'Scb',
              contactMethod: 'john_doe',
              tel: '0233333333',
              taxId: '11222333232232',
              invoiceNumber: 'AA-12345',
              taxInvoice: 'AA-23X-12344421',
              createdAt: '10/10/2022 10:10',
              transferredAt: '10/10/2022 10:10',
              taxInvoiceDate: '10/10/2022 10:10',
              normalInvoiceNumber: 'AA-23X-12344421',
              printedAt: '10/10/2022 10:10',
              createdBy: '',
              markTransferredAt: '10/10/2022 10:10',
              closedAt: '10/10/2022 10:10',
              closedNote: 'TH1505558778',
              shippingType: 'EMS',
              shippingFee: 10,
              orderDiscount: 0,
              promoCode: '',
              promoCodeDiscount: 0,
              totalDiscount: 0,
              annotation: 'Lorem is amut',
              stockName: 'Main',
              purchases,
              cartPurchases: purchases,
              cartPurchasesAndShipping: [
                ...purchases,
                { name: '', quantity: 1, price: 0 }
              ],
              cartPurchaseStr: purchases.map((p) => `${p.name} = ${p.quantity}`).join(' / '),
              shippingSortingCode: '012-1BA259-42',
              shippingTrackingCode: 'TH1505558778',
              shippopPurchaseId: 'SP01234567890',
              shippopTrackingCode: 'E1505558778',
              flashDstStoreName: 'DST-Bankok_centra',
              flashSortingLineCode: 'C08',
              // slug
              slug: '&#DWEXS',
              cod,
              noCod,
              taxable,
              noTaxable,
              codWithTaxable,
              codWithNoTaxable,
              noCodWithTaxable,
              noCodWithNoTaxable
              // cod: cod || codWithNoTaxable || codWithTaxable,
              // noCod: noCod || noCodWithNoTaxable || noCodWithTaxable,
              // taxable: taxable || noCodWithTaxable || codWithTaxable,
              // noTaxable: noTaxable || noCodWithNoTaxable || codWithNoTaxable,
              // codWithTaxable: codWithTaxable || cod || taxable,
              // codWithNoTaxable: codWithNoTaxable || cod || noTaxable,
              // noCodWithTaxable: noCodWithTaxable || noCod || taxable,
              // noCodWithNoTaxable: noCodWithNoTaxable || noCod || noTaxable
            }
          }]
        })
      })
    }
  }
}
